import React from 'react'
import { observer, inject } from 'mobx-react'

import './styles.scss'

/**
 * Tells a tab with unsaved edits that the document was saved elsewhere in the
 * meantime, by someone else or in another tab. Without `modified_by` the API
 * cannot say which, so the copy names both.
 *
 * Informational only — autosave is untouched and this tab will still win. The
 * blocking conflict dialog is a later slice (PRO-621). See FE-1354.
 *
 * Rendered conditionally rather than toggled with a class, unlike the warnings
 * it shares the banner row with: `role="alert"` only announces when the region
 * enters the accessibility tree, and this message appears without any user
 * action.
 */
export const RemoteChangeWarning = ({ app, editor }) => {
  if (!editor.showRemoteChangeWarning) {
    return null
  }

  return (
    <div className="remote-change-warning" role="alert">
      <div>
        <span className="remote-change-warning--message">
          {app.formatMessage('remoteChange.warning')}
        </span>
      </div>
      <div>
        <button
          type="button"
          onClick={editor.dismissRemoteChange}
          className="remote-change-warning--btn bp6-button bp6-intent-warning bp6-icon-cross"
        >
          {app.formatMessage('remoteChange.dismiss')}
        </button>
      </div>
    </div>
  )
}

export default inject('app', 'editor')(observer(RemoteChangeWarning))
